// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3yc4I","options":"AnswerScale_options__N46s5","selected":"AnswerScale_selected__bbg7L"};